import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../common/components/apiConfig";
// import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../common/method/handleNotificationAlert'

export const actionTypes = {
  loadingTrue: "loadingTrue [Action]",
  loadingFalse:"loadingFalse [Action]"
};
const inistiaState = {
  loading:false
};

export const loading = (state = inistiaState, { type, payload }) => {
  switch (type) {
    case actionTypes.loadingTrue:
      return {
        loading:true
      };
    case actionTypes.loadingFalse:
      return {
        loading:false
      };
    default:
      return state;
  }
};

